import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.function.name.js";
import React from 'react';

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
/**
 * This is a higher-order function that returns a higher-order component.
 * The returned high-order component is a function that takes a component
 * and returns a new component. withFSM will return a new component with
 * the given state machine and component connected together.
 *
 * @example
 * import { ReactFSM } from '@nerdwallet/state-machine/react;
 * import { withFSM, FlowContainer } from '@nerdwallet/react-flow';
 *
 * class SomeStateMachine extends ReactFSM {...}
 * const SomeComponent = () => {...}
 *
 * export default withFSM(SomeStateMachine)(SomeComponent)
 */


export default (function (StateMachine) {
  return function (Component) {
    var WithFSM = /*#__PURE__*/function (_React$Component) {
      _inherits(WithFSM, _React$Component);

      var _super = _createSuper(WithFSM);

      function WithFSM(props) {
        var _this;

        _classCallCheck(this, WithFSM);

        _this = _super.call(this, props); // create the state machine

        _this.fsm = new StateMachine();

        var methods = _this.fsm.getMethods();

        _this.fsm.extendFSM({
          methods: {
            onEnterState: function onEnterState() {
              // wait for the state machine to be initialized before updating state
              // prevent update before component is mounted or no reference to component
              if (_this.fsm.getIsInitialized()) {
                _this.setState({
                  fsmCurrentState: _this.fsm.getCurrentState()
                });
              }

              return methods.onEnterState.apply(methods, arguments);
            }
          }
        });

        _this.fsm.initialize();

        _this.state = {
          fsmCurrentState: _this.fsm.getCurrentState()
        };
        return _this;
      }

      _createClass(WithFSM, [{
        key: "render",
        value: function render() {
          var fsmCurrentState = this.state.fsmCurrentState;
          return /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
            fsm: this.fsm,
            fsmCurrentState: fsmCurrentState
          }));
        }
      }]);

      return WithFSM;
    }(React.Component);

    _defineProperty(WithFSM, "displayName", "WithFSM(".concat(getDisplayName(Component), ")"));

    return WithFSM;
  };
});